module.exports = __webpack_public_path__ + "img/4.c5e43f23.png";